<!-- メンテナンス設定タブ -->
<div class="maintenance-settings">
    <!-- 現在の告知の表示状況 -->
    <div class="maintenance-section">
        <h3>現在の告知の表示状況</h3>
        <div class="current-notice-display">
            <div *ngIf="currentNoticeLoading" class="loading-indicator">
                読み込み中...
            </div>
            <ng-container *ngIf="!currentNoticeLoading && currentNotices.length > 0">
                <div *ngFor="let notice of currentNotices" class="notice-content">
                    <div class="notice_html_content" [innerHTML]="notice.noticeText"></div>
                    <p *ngIf="notice.noticeStartDate" class="notice_start_date">{{ notice.noticeStartDate | date:'yyyy-MM-dd' }}</p>
                </div>
            </ng-container>
            <div *ngIf="!currentNoticeLoading && currentNotices.length === 0" class="no-notice">
                現在表示されている告知はありません
            </div>
        </div>
    </div>

    <!-- メンテナンスと告知の設定 -->
    <div class="maintenance-section">
        <h3>メンテナンスと告知の設定</h3>
        <table class="form-table">
            <tbody>
                <!-- MaintenanceID -->
                <tr>
                    <th>MaintenanceID</th>
                    <td>
                        <select [(ngModel)]="selectedMaintenanceId" (change)="onMaintenanceIdChange()" class="form-control">
                            <option value="">-- 新規作成 --</option>
                            <option *ngFor="let item of maintenanceIds" [value]="item.value">
                                {{ item.text }}
                            </option>
                        </select>
                    </td>
                </tr>

                <!-- 表示開始 -->
                <tr>
                    <th>表示開始</th>
                    <td>
                        <div class="datetime-inputs">
                            <input type="number" [(ngModel)]="displayStartYear" placeholder="年" class="year-input" min="2000" max="2100">年
                            <input type="number" [(ngModel)]="displayStartMonth" placeholder="月" class="month-input" min="1" max="12">月
                            <input type="number" [(ngModel)]="displayStartDay" placeholder="日" class="day-input" min="1" max="31">日
                            <input type="number" [(ngModel)]="displayStartHour" placeholder="時" class="hour-input" min="0" max="23">時
                            <input type="number" [(ngModel)]="displayStartMinute" placeholder="分" class="minute-input" min="0" max="59">分
                        </div>
                        <div class="checkbox-wrapper">
                            <label>
                                <input type="checkbox" [(ngModel)]="setCurrentDate" (change)="onSetCurrentDateChange()">
                                現在日時をセット
                            </label>
                        </div>
                    </td>
                </tr>

                <!-- 表示終了 -->
                <tr>
                    <th>表示終了</th>
                    <td>
                        <div class="datetime-inputs">
                            <input type="number" [(ngModel)]="displayEndYear" placeholder="年" class="year-input" min="2000" max="2100">年
                            <input type="number" [(ngModel)]="displayEndMonth" placeholder="月" class="month-input" min="1" max="12">月
                            <input type="number" [(ngModel)]="displayEndDay" placeholder="日" class="day-input" min="1" max="31">日
                            <input type="number" [(ngModel)]="displayEndHour" placeholder="時" class="hour-input" min="0" max="23">時
                            <input type="number" [(ngModel)]="displayEndMinute" placeholder="分" class="minute-input" min="0" max="59">分
                        </div>
                    </td>
                </tr>

                <!-- テンプレート -->
                <tr>
                    <th>テンプレート</th>
                    <td>
                        <select [(ngModel)]="selectedTemplate" (change)="onTemplateChange()" class="form-control">
                            <option value="">-- テンプレートを選択 --</option>
                            <option *ngFor="let template of templates" [value]="template.templateId">
                                {{ template.templateName }}
                            </option>
                        </select>
                    </td>
                </tr>

                <!-- 告知内容 -->
                <tr>
                    <th>告知内容</th>
                    <td>
                        <textarea [(ngModel)]="noticeContent" rows="6" class="form-control"></textarea>
                    </td>
                </tr>

                <!-- サービス停止開始 -->
                <tr>
                    <th>サービス停止開始</th>
                    <td>
                        <div class="datetime-inputs">
                            <input type="number" [(ngModel)]="stopStartYear" placeholder="年" class="year-input" min="2000" max="2100">年
                            <input type="number" [(ngModel)]="stopStartMonth" placeholder="月" class="month-input" min="1" max="12">月
                            <input type="number" [(ngModel)]="stopStartDay" placeholder="日" class="day-input" min="1" max="31">日
                            <input type="number" [(ngModel)]="stopStartHour" placeholder="時" class="hour-input" min="0" max="23">時
                            <input type="number" [(ngModel)]="stopStartMinute" placeholder="分" class="minute-input" min="0" max="59">分
                        </div>
                    </td>
                </tr>

                <!-- サービス停止終了 -->
                <tr>
                    <th>サービス停止終了</th>
                    <td>
                        <div class="datetime-inputs">
                            <input type="number" [(ngModel)]="stopEndYear" placeholder="年" class="year-input" min="2000" max="2100">年
                            <input type="number" [(ngModel)]="stopEndMonth" placeholder="月" class="month-input" min="1" max="12">月
                            <input type="number" [(ngModel)]="stopEndDay" placeholder="日" class="day-input" min="1" max="31">日
                            <input type="number" [(ngModel)]="stopEndHour" placeholder="時" class="hour-input" min="0" max="23">時
                            <input type="number" [(ngModel)]="stopEndMinute" placeholder="分" class="minute-input" min="0" max="59">分
                        </div>
                    </td>
                </tr>

                <!-- 代替URL -->
                <tr>
                    <th>代替URL</th>
                    <td>
                        <input type="text" [(ngModel)]="alternativeUrl" class="form-control" placeholder="https://">
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="form-actions">
            <button (click)="saveNotice()" class="btn btn-primary">保存/更新</button>
            <button (click)="clearNotice()" class="btn btn-secondary">クリア</button>
            <button (click)="deleteNotice()" class="btn btn-danger">削除</button>
        </div>
    </div>

    <!-- テンプレートの追加/修正 -->
    <div class="maintenance-section">
        <h3>テンプレートの追加/修正</h3>
        <table class="form-table">
            <tbody>
                <!-- テンプレート選択 -->
                <tr>
                    <th>テンプレート選択</th>
                    <td>
                        <select [(ngModel)]="selectedTemplateForEdit" (change)="onTemplateForEditChange()" class="form-control">
                            <option value="">-- 新規作成 --</option>
                            <option *ngFor="let template of editableTemplates" [value]="template.templateId">
                                {{ template.templateName }}
                            </option>
                        </select>
                    </td>
                </tr>

                <!-- テンプレート名 -->
                <tr>
                    <th>テンプレート名</th>
                    <td>
                        <input type="text" [(ngModel)]="templateName" class="form-control">
                    </td>
                </tr>

                <!-- テンプレート種類 -->
                <tr>
                    <th>テンプレート種類</th>
                    <td>
                        <div class="radio-group">
                            <label>
                                <input type="radio" name="templateType" [(ngModel)]="templateType" value="1">
                                メール
                            </label>
                            <label>
                                <input type="radio" name="templateType" [(ngModel)]="templateType" value="2">
                                メンテナンス
                            </label>
                            <label>
                                <input type="radio" name="templateType" [(ngModel)]="templateType" value="3">
                                通知
                            </label>
                        </div>
                    </td>
                </tr>

                <!-- タイトル -->
                <tr>
                    <th>タイトル</th>
                    <td>
                        <input type="text" [(ngModel)]="templateTitle" class="form-control">
                    </td>
                </tr>

                <!-- 内容 -->
                <tr>
                    <th>内容</th>
                    <td>
                        <textarea [(ngModel)]="templateContent" rows="6" class="form-control"></textarea>
                    </td>
                </tr>

                <!-- 対象 -->
                <tr>
                    <th>対象</th>
                    <td>
                        <div class="radio-group">
                            <label>
                                <input type="radio" name="templateTarget" [(ngModel)]="templateTarget" value="0">
                                全員
                            </label>
                            <label>
                                <input type="radio" name="templateTarget" [(ngModel)]="templateTarget" value="1">
                                ASC
                            </label>
                            <label>
                                <input type="radio" name="templateTarget" [(ngModel)]="templateTarget" value="2">
                                承認者
                            </label>
                            <label>
                                <input type="radio" name="templateTarget" [(ngModel)]="templateTarget" value="3">
                                MP社員
                            </label>
                        </div>
                    </td>
                </tr>

                <!-- 送信元メールアドレス -->
                <tr>
                    <th>送信元メールアドレス</th>
                    <td>
                        <input type="email" [(ngModel)]="senderEmail" class="form-control">
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="form-actions">
            <button (click)="saveTemplate()" class="btn btn-primary">保存/更新</button>
            <button (click)="clearTemplate()" class="btn btn-secondary">クリア</button>
            <button (click)="deleteTemplate()" class="btn btn-danger">削除</button>
        </div>
    </div>
</div>
